export function escapeSpecialSymbols(string: string): string {
  return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}

export function includesCaseInsensitive(text: string, searchTerm: string): boolean {
  return text?.toLowerCase().includes(searchTerm.toLowerCase()) === true;
}
